export default "__VITE_PUBLIC_ASSET__11076356__"